export default {
  computed: {
    teamMembers () {
      return this.$store.state.TeamMembers.data
    },
    teamMembersExceptMe () {
      return this.$store.state.TeamMembers.data.filter(teamMember => this.spark.state.user.id !== teamMember.id)
    }
  },
  mounted () {
    if (Spark.hasTeam()) {
      this.$store.dispatch('TeamMembers/loadData', {})
    }
  }
}
